import React from 'react';
import { GigsCarousel } from '@fiverr-private/cms_ui';
import {} from 'prop-types';
import { translateUGC } from '../services/translateUGC';

const GigsCarouselCustom = (props) => {

    const onTranslateUGC = async(UGC) =>
        translateUGC(UGC);

    return (
        <div className="gigs-carousel-custom">
            <GigsCarousel {...props}
                useMT={true}
                translateUGC={onTranslateUGC}/>
        </div>
    );
};

export default GigsCarouselCustom;
